
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoSocialButton',
  components: { EoIcon },
  props: {
    /**
     * Platform (clubhouse) (facebook) (instagram) (snapchat) 
     * (soundcloud) (spotify) (tiktok) (twitter)
     * (vimeo) (whatsapp) (youtube)
     */
    platform: {
      type: String,
      default: '',
      required: true,
      validator: prop => Object.values([
        'clubhouse',
        'facebook',
        'instagram',
        'snapchat',
        'soundcloud',
        'spotify',
        'tiktok',
        'twitter',
        'vimeo',
        'whatsapp',
        'youtube',
      ]).includes(prop),
    },
    /**
     * URL to link to
     */
    to: {
      type: String,
      default: null,
      required: true,
    },
    /**
     * Purpose of the button (share) (profile) (other)
     */
    purpose: {
      type: String,
      default: 'profile',
      validator: prop => Object.values([
        'share',
        'profile',
        'other',
      ]).includes(prop),
    },
    
  },
  computed: {
    classes () {
      return {
        'eo-social-button': true,
        ['is-' + this.platform]: true,
      }
    },
    icon () {
      if (this.platform?.toLowerCase() === 'snapchat') {
        return 'snapchat-outline'
      }
      if (this.platform?.toLowerCase() === 'twitter') {
        return 'x'
      }
      return this.platform?.toLowerCase()
    },
    label () {
      switch (this.purpose) {
        case 'share':
          return `Delen via ${this.platform}`
        case 'profile':
          return `Volg ons op ${this.platform}`
        case 'other':
        default:
          return `Ga naar ${this.platform}`
      }
    },
  },
}
